export const findObjectiveTableObject = (arr, id, key = 'dataObj', childrenKey = 'children') => {
  // https://stackoverflow.com/a/52205522/8487836
  let result;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key]['1'].uuid === id) {
      result = arr[i];
      break;
    }
    if (arr[i][childrenKey]) {
      result = findObjectiveTableObject(arr[i][childrenKey], id);
      if (result) break;
    }
  }
  return result;
};

export const insertObjectiveInObjectiveTable = (
  arr,
  id,
  objectiveToBeAdded = {},
  key = 'dataObj',
  childrenKey = 'children'
) => {
  const arrCopy = [...arr];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key]['1'].uuid === id) {
      // inserting
      if (arr[i][childrenKey] && Array.isArray(arr[i][childrenKey])) {
        arrCopy[i] = { ...arrCopy[i], [childrenKey]: [...arr[i][childrenKey], objectiveToBeAdded] };
      } else {
        arrCopy[i] = { ...arrCopy[i], [childrenKey]: [objectiveToBeAdded] };
      }

      break;
    }
    if (arr[i][childrenKey]) {
      const updatedChildren = insertObjectiveInObjectiveTable(arr[i][childrenKey], id, objectiveToBeAdded);
      arrCopy[i] = { ...arrCopy[i], [childrenKey]: updatedChildren };
    }
  }
  return arrCopy;
};

export const generateObjectiveObjectTemplate = ({ objectiveTimeBoundId, name, level, postCardId }) => ({
  children: null,
  goals: null,
  level: level + 1,
  parentUuid: null,
  dataObj: {
    1: {
      uuid: objectiveTimeBoundId,
      postCardId,
      value: name,
      imageUrl: null,
      managerUuid: null,
      feedbackFormId: null,
      employee: null,
      isPublished: null,
      isClickable: null,
    },
    3: {
      uuid: null,
      value: null,
      imageUrl: null,
      managerUuid: null,
      feedbackFormId: null,
      employee: null,
      isPublished: null,
      isClickable: null,
    },
    5: {
      uuid: '',
      overall: {
        avgCompletionPercentage: '0',
        count: 0,
      },
      value: null,
      imageUrl: '',
      managerUuid: null,
      feedbackFormId: null,
      employee: null,
      isPublished: null,
      isClickable: null,
    },
    6: {
      uuid: '',
      value: {
        COMPLETED_PERCENTAGE: 0,
        AT_RISK: {
          COMPLETED_PERCENTAGE: 0,
          COUNT: 0,
        },
        CLOSED: {
          COMPLETED_PERCENTAGE: 0,
          COUNT: 0,
        },
        ON_TRACK: {
          COMPLETED_PERCENTAGE: 0,
          COUNT: 0,
        },
        PROGRESS_LEVEL: 'ON_TRACK',
        COUNT: 0,
        OFF_TRACK: {
          COMPLETED_PERCENTAGE: 0,
          COUNT: 0,
        },
      },
      imageUrl: '',
      managerUuid: null,
      feedbackFormId: null,
      employee: null,
      isPublished: null,
      isClickable: null,
    },
  },
});
